<template>
  <t-form labelWidth="80px">
    <e-collapse title="基础设置" :expand="true">
      <t-form-item label="上边距">
        <t-input-number
          size="small"
          v-model="attribute.top"
          theme="normal"
          align="left"
          :min="0"
          :max="9999"
          :decimal-places="0"
        >
          <template #suffix><span>px</span></template>
        </t-input-number>
      </t-form-item>
      <t-form-item label="下边距">
        <t-input-number
          size="small"
          v-model="attribute.bottom"
          theme="normal"
          align="left"
          :min="0"
          :max="9999"
          :decimal-places="0"
        >
          <template #suffix><span>px</span></template>
        </t-input-number>
      </t-form-item>
      <t-form-item label="左边距">
        <t-input-number
          size="small"
          v-model="attribute.left"
          theme="normal"
          align="left"
          :min="0"
          :max="9999"
          :decimal-places="0"
        >
          <template #suffix><span>px</span></template>
        </t-input-number>
      </t-form-item>
      <t-form-item label="右边距">
        <t-input-number
          size="small"
          v-model="attribute.right"
          theme="normal"
          align="left"
          :min="0"
          :max="9999"
          :decimal-places="0"
        >
          <template #suffix><span>px</span></template>
        </t-input-number>
      </t-form-item>
      <t-form-item label="背景颜色">
        <t-color-picker
          size="small"
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.bgColor"
        />
      </t-form-item>
    </e-collapse>
    <e-collapse title="字体设置" :expand="true">
      <t-form-item label="字体颜色">
        <t-color-picker
          size="small"
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.textColor"
        />
      </t-form-item>
      <t-form-item label="字体样式">
        <t-radio-group size="small" v-model="attribute.fontStyle">
          <t-radio-button value="normal">正常</t-radio-button>
          <t-radio-button value="italic">斜体</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="加粗">
        <t-radio-group size="small" v-model="attribute.fontWeight">
          <t-radio-button value="normal">正常</t-radio-button>
          <t-radio-button value="bold">加粗</t-radio-button>
          <t-radio-button value="lighter">更细</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="字体">
        <t-select size="small" v-model="attribute.fontFamily">
          <t-option
            v-for="item in textFamilyList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </t-select>
      </t-form-item>
      <t-form-item label="字体大小">
        <t-input-number
          size="small"
          :min="0"
          :max="9999"
          v-model="attribute.fontSize"
          :decimal-places="0"
        />
      </t-form-item>
    </e-collapse>
    <e-collapse title="边框设置" :expand="true">
      <t-form-item label="边框宽度">
        <t-input-number
          size="small"
          v-model="attribute.borderSize"
          :min="0"
          :max="9999"
          :decimal-places="0"
        />
      </t-form-item>
      <t-form-item label="边框颜色">
        <t-color-picker
          size="small"
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.borderColor"
        />
      </t-form-item>
      <t-form-item label="边框圆角">
        <t-input-number
          size="small"
          v-model="attribute.borderRadius"
          :min="0"
          :max="9999"
          :decimal-places="0"
          
        />
      </t-form-item>
      <t-form-item label="线条类型">
        <t-select size="small" v-model="attribute.lineType">
          <t-option
            v-for="item in lineTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </t-select>
      </t-form-item>
    </e-collapse>
    <e-collapse title="选中设置" :expand="true">
      <t-form-item label="选中背景颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.activeBgColor"
          size="small"
        />
      </t-form-item>
      <t-form-item label="选中边框颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.activeBrColor"
          size="small"
        />
      </t-form-item>
      <t-form-item label="选中字体颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.activeColor"
          size="small"
        />
      </t-form-item>
    </e-collapse>
  </t-form>
</template>

<script>
export default {
  name: "cpt-input-select-option",
  props: {
    attribute: Object,
    currentCpt: Object,
  },
};
</script>

<style scpped>

</style>